import { PricingSetFragment, RateGroupKindEnum } from '@graphql/platform';

import { Commitment } from '@root/resources/types/commitment';
import { PlanName } from '@root/resources/types/plan_name';

import { roundedDiscountPercentage } from '@utils/hooks/pricing/use_pricing_summary';
import { extractStoragePrice } from '@utils/pricing/pricing_set';

/**
 * New-funnel commitment pill % off month-to-month for Flexer/Saver.
 * Same rounding as classic commitment cards (nearest multiple of 5).
 */
export const commitmentDiscountPercents = (
  planSize: PlanName | undefined,
  pricingSet: PricingSetFragment | undefined,
): Partial<Record<Commitment, number>> => {
  const discounts: Partial<Record<Commitment, number>> = {};
  if (!planSize || !pricingSet) return discounts;

  const mover = extractStoragePrice(
    RateGroupKindEnum.Mover,
    planSize,
    pricingSet,
  );
  const flexer = extractStoragePrice(
    RateGroupKindEnum.Flexer,
    planSize,
    pricingSet,
  );
  const saver = extractStoragePrice(
    RateGroupKindEnum.Saver,
    planSize,
    pricingSet,
  );

  if (mover == null || mover <= 0) return discounts;

  if (flexer != null) {
    const pct = roundedDiscountPercentage(mover, flexer);
    if (pct > 0) discounts[RateGroupKindEnum.Flexer] = pct;
  }
  if (saver != null) {
    const pct = roundedDiscountPercentage(mover, saver);
    if (pct > 0) discounts[RateGroupKindEnum.Saver] = pct;
  }

  return discounts;
};
